<template>
  <v-row no-gutters align="center">
    <v-col class="d-flex justify-center align-center" cols="3">
      <v-progress-circular
        :size="10"
        :width="1"
        class="p-absolute"
        :color="isLoading ? 'primary' : 'white'"
        indeterminate
      />

      <v-btn
        @click="paginationBackward"
        :disabled="currentPage <= 1 || isLoading"
        elevation="0"
        icon
      >
        <v-icon dark>
          mdi-chevron-left
        </v-icon>
      </v-btn>
    </v-col>

    <v-col class="d-flex justify-center align-center" cols="2">
      <v-text-field
        class="ma-0"
        @change="goToPage"
        :value="currentPage"
        :disabled="isLoading"
        hide-details
        dense
      />
    </v-col>

    <v-col
      class="d-flex justify-center align-center grey--text darken-3"
      cols="2"
    >
      de
    </v-col>

    <v-col class="d-flex justify-center align-center" cols="2">
      {{ totalPages }}
    </v-col>

    <v-col class="d-flex justify-center align-center" cols="3">
      <v-btn
        @click="paginateForward"
        :disabled="currentPage >= totalPages || isLoading"
        elevation="0"
        icon
      >
        <v-icon dark>
          mdi-chevron-right
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import store from '@/store'

export default {
  name: 'PaginationSelect',

  props: {
    fetch: {
      type: Function,
      required: true,
    },
    fetchParams: {
      type: Array,
      required: false
    },
  },

  data() {
    return {
      page: store.getters.currentPage,
      isLoading: false,
    }
  },

  computed: {
    ...mapGetters(['currentPage', 'totalPages']),
  },

  methods: {
    ...mapMutations(['setCurrentPage']),

    goToPage(value) {
      if (value >= 1 && value <= this.totalPages) {
        this.isLoading = true

        Promise.resolve(this.setCurrentPage(value))
          .then(() => this.callFetchFunction())
          .then(() => this.scrollToTop())
          .finally(() => (this.isLoading = false))
      }
    },

    paginateForward() {
      if (this.currentPage < this.totalPages) {
        this.isLoading = true

        Promise.resolve(this.setCurrentPage(this.currentPage + 1))
          .then(() => this.callFetchFunction())
          .then(() => this.scrollToTop())
          .finally(() => (this.isLoading = false))
      }
    },

    paginationBackward() {
      if (this.currentPage > 1) {
        this.isLoading = true

        Promise.resolve(this.setCurrentPage(this.currentPage - 1))
          .then(() => this.callFetchFunction())
          .then(() => this.scrollToTop())
          .finally(() => (this.isLoading = false))
      }
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    callFetchFunction() {
      if (this.fetchParams) {
        this.fetch(...this.fetchParams)
      } else {
        this.fetch()
      }
    },
  },
}
</script>
